import { FilterDef } from "@/stores/filters/FilterDef";
import { Interval } from "luxon";

import {FilterParamValue} from "@/stores/filters/FilterParamValue";

export class ObservationFilterDef extends FilterDef {

	constructor() {
		super([
			'pupilIds',
			'activityIds',
			'classroomIds',
			'start',
			'end',
			'query',
			'goalIds',
		]);
	}

	setInterval(interval: Interval | null) {

		if (interval && interval.start && interval.end) {
			this.setParamValues('start', [new FilterParamValue(interval.start.toUTC().toISO(), interval.start.toUTC().toISO())]);
			this.setParamValues('end', [new FilterParamValue(interval.end.toUTC().toISO(), interval.end.toUTC().toISO())]);
		} else {
			this.clearParam('start');
			this.clearParam('end');
		}
	}

	get pupilId(): string | null {
		return this.getParamValues('pupilIds')[0]?.id.toString() || null;
	}

	set pupilId(value: string) {
		this.setParamValues('pupilIds', [new FilterParamValue(value, value)]);
	}

	get activityId(): string | null {
		return this.getParamValues('activityIds')[0]?.id.toString() || null;
	}

	set activityId(value: string) {
		this.setParamValues('activityIds', [new FilterParamValue(value, value)]);
	}

	get keywords(): string | null {
		return this.getParamValues('query')[0]?.id.toString() || null;
	}

	set keywords(value: string) {
		this.setParamValues('query', [new FilterParamValue(value, value)]);
	}

	get goalId(): string | null {
		return this.getParamValues('goalIds')[0]?.id.toString() || null;
	}

	set goalId(value: string) {
		this.setParamValues('goalIds', [new FilterParamValue(value, value)]);
	}

	get classroomIds(): string[] {
		return this.getParamValues('classroomIds').map(v => v.id.toString());
	}

	set classroomIds(value: string[]) {
		this.setParamValues('classroomIds', value.map(id => new FilterParamValue(id, id)));
	}

}
